import React, { useEffect, useRef, useState } from "react";
import { addRecordingServer } from "../Action/adminPanelAction";
import { useDispatch } from "react-redux";
import moment from "moment";
import WaitingRecordingPopup from "./waitingRecordingPopup";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import VoiceOverOffIcon from "@mui/icons-material/VoiceOverOff";
import ReplyIcon from "@mui/icons-material/Reply";
import LogoutIcon from "@mui/icons-material/Logout";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import LiveClassInstructionsPopup from "./liveClassInstructionsPopup";

const JitsiComponent = ({
  displayName,
  roomName,
  domain,
  token,
  onCallEnd,
  onCallLeave,
  classScheduleId,
} = Props) => {
  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const apiRef = useRef(null);
  const [isRecording, setIsRecording] = useState(false);
  const [isTimer, setIsTimer] = useState(false);
  const [IsInstructions, setIsInstructions] = useState(false);
  const [isButtonclicked, setIsbuttonClicked] = useState("");

  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      const api = new window.JitsiMeetExternalAPI(domain, {
        roomName,
        jwt: token,
        width: "100%",
        height: "100%",
        parentNode: containerRef.current,
        configOverwrite: {
          prejoinPageEnabled: false, // Hides Pre Join Page
          startWithAudioMuted: true, // Optional: Mutes audio if desired
          startWithVideoMuted: false, // Mutes video when joining
          // hideConferenceSubject: true, // Hides room name (subject)
          // disableVideoQualityLabel: true, // Hides video quality label
          // disablePolls: true, // Hides the polls option in chat
          // SHOW_PERFORMANCE_SETTINGS: false,
          // disableTileView: true,
          participantsPane: {
            enabled: true,
            hideOnStart: true,
            hideModeratorSettingsTab: false,
            hideMoreActionsButton: false,
            hideMuteAllButton: false,
          },
          breakoutRooms: {
            hideAddRoomButton: true,
          },
          notifications: ["notify.chatMessages"],
          // speakerStats: {
          //   disabled: true,
          // },
          // startWithFollowMe: true,
          // DISABLE_SOUNDS: [
          //   "PARTICIPANT_JOINED_SOUND",
          //   "PARTICIPANT_LEFT_SOUND",
          //   "RECORDING_ON_SOUND",
          //   "RECORDING_OFF_SOUND",
          // ],
        },
        interfaceConfigOverwrite: {
          // TILE_VIEW_ENABLED: false,
          // FILM_STRIP_MAX_HEIGHT: 0,
          // DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
          // SHOW_PARTICIPANT_STATS: false,
          // SHOW_NOTIFICATION_BAR: false,
          // disabledNotifications: [
          //   "recordingStarted",
          //   "recordingStopped",
          //   "participantJoined",
          //   "participantLeft",
          //   "liveStreamingStarted",
          //   "liveStreamingStopped",
          //   "videoQualityLow",
          // ],
          TOOLBAR_BUTTONS: [
            "microphone",
            "camera",
            "fullscreen",
            "chat",
            "settings",
            "desktop",
            "participants-pane",
            // "raisehand",
            // "filmstrip",
            // "recording",
          ],
        },
        userInfo: {
          displayName: displayName,
        },
      });

      apiRef.current = api;

      api.on("participantRoleChanged", function (event) {
        if (event.role === "moderator") {
          api.pinParticipant(event.id);
        }
      });

      api.addEventListener("participantJoined", (event) => {
        api.getRoomsInfo().then((rooms) => {
          rooms?.rooms.forEach((room) => {
            const prevArr = room.participants.filter((participant) => {
              return participant?.displayName === event?.displayName;
            });

            const participants = prevArr?.filter(
              (item) => item?.id !== event?.id
            );
            participants.map((p) => {
              // const participantName = p.displayName.split(" ");
              // api.executeCommand(
              //   "sendChatMessage",
              //   `${participantName[0]} ${participantName[1]} you are being removed due to multiple logins`
              // );
              api.executeCommand("sendEndpointTextMessage", p.id, {
                type: "MULTI_LOGIN_ALERT",
                message: "You are being removed due to multiple logins",
              });
              setTimeout(() => {
                api.executeCommand("kickParticipant", p.id);
              }, 3000);
            });
          });
        });
      });

      api.addEventListener("videoConferenceJoined", () => {
        handleStartRecording();
      });

      api.on("toolbarButtonClicked", (event) => {
        if (event.key == "fullscreen") {
          setTimeout(() => {
            api.executeCommand("resizeFilmStrip", { width: 129 });
            api.executeCommand("resizeLargeVideo", {
              width: 1200, // The desired width
              height: 650, // The desired height
            });
          }, 100); // Delay of 500ms (you can adjust this value)
        }
      });

      api.addEventListener("chatUpdated", (event) => {
        const isChatOpen = event.isOpen;
        if (isChatOpen) {
          api.executeCommand("resizeLargeVideo", {
            width: 1200, // Adjust the video size when chat is open
            height: 650,
          });
        } else {
          api.executeCommand("resizeLargeVideo", {
            width: 1200, // Default video size when chat is closed
            height: 650,
          });
        }
      });

      return () => {
        api.dispose();
      };
    }
  }, [domain, roomName, displayName]);

  const handleStartRecording = () => {
    const options = {
      mode: "file",
      recordingType: "full",
    };
    apiRef.current.startRecording(options);
    apiRef.current.addListener("recordingStatusChanged", (status) => {
      if (status.on) {
        setIsRecording(true);
      } else {
        setIsRecording(false);
      }
    });
  };

  const handleAudioMuteChanged = ({ muted }) => {
    apiRef.current.getRoomsInfo().then((rooms) => {
      const tempModerator = rooms?.rooms[0]?.participants?.find(
        (item) => item?.role === "moderator"
      );

      if (muted === false && tempModerator) {
        apiRef.current.executeCommand("toggleAudio");
      }
    });
  };

  const handleMuteAll = async () => {
    apiRef.current.executeCommand("muteEveryone");

    apiRef.current.addListener(
      "audioMuteStatusChanged",
      handleAudioMuteChanged
    );

    setTimeout(() => {
      apiRef.current.removeListener(
        "audioMuteStatusChanged",
        handleAudioMuteChanged
      );
    }, 500);
  };

  const addRecorder = () => {
    let currentTime = moment().add(3, "minute").format("HH:mm:ss");
    let postData = {
      classScheduleId: classScheduleId,
      restartServerTime: currentTime,
    };
    dispatch(
      addRecordingServer(
        postData,
        (res) => {
          if (res?.statusCode === 200) {
            setTimeLeft(5 * 60);
            setIsTimer(true);
          }
        },
        () => {}
      )
    );
  };

  const handleLeaveMeeting = () => {
    apiRef.current?.executeCommand("hangup");
    onCallLeave();
  };

  // const handleEndMeeting = async () => {
  //   try {
  //     const participants = await apiRef.current.getParticipantsInfo();
  //     for (const participant of participants) {
  //       if (!participant) {
  //         try {
  //           await apiRef.current.executeCommand(
  //             "kickParticipant",
  //             participant.participantId
  //           );
  //         } catch (kickError) {
  //           console.warn(
  //             `Failed to kick participant ${participant.displayName}`,
  //             kickError
  //           );
  //         }
  //       }
  //     }

  //     await new Promise((resolve) => setTimeout(resolve, 800));

  //     // Delay to allow kick propagation
  //     setTimeout(() => {
  //       apiRef.current?.executeCommand("hangup");
  //       onCallEnd(); // meeting ended for all
  //     }, 3000);
  //   } catch (error) {}
  // };

  const handleEndMeeting = async () => {
    try {
      const api = apiRef.current;
      if (!api) return;
      // 1️⃣ Get all participants
      api.getRoomsInfo().then(async (rooms) => {
        const participants = rooms?.rooms[0]?.participants?.filter(
          (item) => item.role !== "moderator"
        );
        // 2️⃣ Prepare kick operations in parallel (skip local moderator)
        participants.map((p) => {
          return api.executeCommand("kickParticipant", p.id);
        });

        // 3️⃣ Wait briefly to ensure server processes kicks
        await new Promise((res) => setTimeout(res, 600));

        // 4️⃣ Leave the meeting yourself
        api.executeCommand("hangup");

        // 5️⃣ Give Jitsi time to cleanly disconnect
        await new Promise((res) => setTimeout(res, 300));

        // 6️⃣ Notify parent application
        onCallEnd?.();

        // 7️⃣
      });
    } catch (error) {
      console.error("Error ending meeting:", error);
    }
  };

  useEffect(() => {
    if (timeLeft === 240) {
      apiRef.current.executeCommand(
        "sendChatMessage",
        `Please Wait. Your class will begin in ${formatTime()} minutes.`
      );
    }
    if (timeLeft === 180) {
      apiRef.current.executeCommand(
        "sendChatMessage",
        `Please Wait. Your class will begin in ${formatTime()} minutes.`
      );
    }
    if (timeLeft === 120) {
      apiRef.current.executeCommand(
        "sendChatMessage",
        `Please Wait. Your class will begin in ${formatTime()} minutes.`
      );
    }
    if (timeLeft === 60) {
      apiRef.current.executeCommand(
        "sendChatMessage",
        `Please Wait. Your class will begin in less than a ${formatTime()} minute.`
      );
    }
    if (timeLeft === 13) {
      handleStartRecording();
    }
    if (timeLeft <= 0) {
      apiRef.current.executeCommand(
        "sendChatMessage",
        `Your class is starting now!`
      );
      setIsTimer(false);
      return;
    }

    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  const formatTime = () => {
    const minutes = String(Math.floor(timeLeft / 60)).padStart(2, "0");
    const seconds = String(timeLeft % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Jitsi Video Container */}
      <div
        ref={containerRef}
        style={{
          flexGrow: 1,
          position: "relative",
          zIndex: 1,
        }}
      />
      {/* Button Container */}
      {isTimer ? (
        <div
          style={{
            padding: "10px",
            textAlign: "center",
            backgroundColor: "#f5f5f5",
            zIndex: 2,
          }}
        >
          <WaitingRecordingPopup open={isTimer} data={formatTime()} />
        </div>
      ) : (
        <div
          style={{
            padding: "10px",
            textAlign: "center",
            backgroundColor: "#f5f5f5",
            zIndex: 2,
          }}
        >
          <button
            title="Instructions"
            onClick={() => {
              setIsInstructions(true);
              setIsbuttonClicked("instructions");
            }}
            style={{
              marginRight: "10px",
              padding: "8px 16px",
              backgroundColor: "#138496",
              color: "white",
              border: "1px solid #138496",
              borderRadius: "8px",
            }}
          >
            <BookmarkBorderIcon fontSize="large" /> Instructions
          </button>
          {!isRecording ? (
            // <button
            //   title="Start Recording"
            //   onClick={() => handleStartRecording()}
            //   style={{
            //     marginRight: "10px",
            //     padding: "8px 16px",
            //     backgroundColor: "#6c757d",
            //     color: "white",
            //     border: "1px solid #6c757d",
            //     borderRadius: "8px",
            //   }}
            // >
            //   <RadioButtonCheckedIcon fontSize="large" />
            // </button>
            <button
              title="Start Recording"
              onClick={() => addRecorder()}
              style={{
                marginRight: "10px",
                padding: "8px 16px",
                backgroundColor: "#28a745",
                color: "white",
                border: "1px solid #28a745",
                borderRadius: "8px",
              }}
            >
              <RadioButtonCheckedIcon fontSize="large" /> Start Recording
            </button>
          ) : null}
          <button
            title="Mute Participants"
            onClick={() => handleMuteAll()}
            style={{
              marginRight: "10px",
              padding: "8px 16px",
              backgroundColor: "#6c757d",
              color: "white",
              border: "1px solid #6c757d",
              borderRadius: "8px",
            }}
          >
            <VoiceOverOffIcon fontSize="large" /> Mute Participants
          </button>

          <button
            title="Leave Meeting"
            onClick={handleLeaveMeeting}
            style={{
              marginRight: "10px",
              padding: "8px 16px",
              backgroundColor: "#ffc107",
              color: "black",
              border: "1px solid #ffc107",
              borderRadius: "8px",
            }}
          >
            <ReplyIcon fontSize="large" /> Leave Meeting
          </button>
          <button
            title="End Meeting for All"
            onClick={handleEndMeeting}
            style={{
              marginRight: "10px",
              padding: "8px 16px",
              fontSize: "14px",
              backgroundColor: "#dc3545",
              color: "white",
              border: "1px solid #dc3545",
              borderRadius: "8px",
            }}
          >
            <LogoutIcon fontSize="large" /> End Meeting for All
          </button>
        </div>
      )}
      {IsInstructions ? (
        <LiveClassInstructionsPopup
          open={IsInstructions}
          handleClose={() => setIsInstructions(false)}
          buttonClicked={isButtonclicked}
        />
      ) : null}
    </div>
  );
};

export default JitsiComponent;
